interface IProps {
  showAnswersByDefault: boolean;
  onToggleShowAnswersByDefault: (value: boolean) => void;
}

export const ReviewModeHeader = ({
  showAnswersByDefault,
  onToggleShowAnswersByDefault,
}: IProps) => {
  return (
    <div className="flex flex-col items-center">
      <div className="inline-flex min-w-[9.5rem] items-center justify-center rounded-full border border-black/20 bg-white/85 px-4 py-1 text-[0.95rem] font-semibold leading-none text-black shadow-[0_1px_2px_rgba(15,23,42,0.08)]">
        Review Mode
      </div>
      <label className="mt-1 inline-flex items-center gap-2 text-[13px] font-medium leading-none text-black/75">
        <input
          type="checkbox"
          className="h-[13px] w-[13px] rounded border border-black/30 accent-[#3558D1]"
          checked={showAnswersByDefault}
          onChange={(event) =>
            onToggleShowAnswersByDefault(event.target.checked)
          }
        />
        <span>Show Answers by Default</span>
      </label>
    </div>
  );
};

